<template>
  <div>
    <PerfectScrollbar class="gf_pricing" id="gfPricing">
      <a class="gf_pricing__close" @click="leavePricingPage">
        <i class="icon icon-cancel"></i>
      </a>
      <template v-if="pricingPageLoading">
        <div class="gf_pricing__intro gf_pricing__container">
          <a @click.prevent="goToDashboard" href="#" class="gf_pricing__intro--logo">
            <img src="../../assets/logo.svg" alt="GemPage" />
          </a>
        </div>
        <PricingPageLoading class="gf_pricing__container" />
      </template>
      <template v-else>
        <div class="gf_pricing__intro gf_pricing__container text-center">
          <h1 class="gf_pricing__intro--title" v-if="!yearlyMode" v-html="$t('dataNewPlan.titleMonth')"></h1>
          <h1 class="gf_pricing__intro--title" v-else v-html="$t('dataNewPlan.titleYear')"></h1>
        </div>
        <div class="gf_pricing__switch gf_pricing__container" :class="{'gf_pricing__affiliate': isShopifyPlanAffiliate}">
          <div class="switcher" @click="toggleYearlyMonthlyMode()">
            <label for="month" class="switcher__label switcher__label__month" :class="{'year_mode': yearlyMode}">Monthly</label>
            <label for="year" class="switcher__label switcher__label__year" :class="{'year_mode': yearlyMode}">Yearly</label>
            <span class="switcher__toggle"></span>
            <img @click.stop="() => { return }" class="switcher__save-20" src="../../assets/save-20.svg" alt="Save 20%" />
          </div>
        </div>
        <div class="gf_pricing__container gf_pricing__notify" v-if="isShopifyPlanAffiliate">
          <Notification 
            ref="notify"
            class="mb-2"
            type="warn"
            @clickEvent="trackingClickLinkNotify"
            :htmlDesc="$t('dataNewPlan.plan.dev.warning.notify', {'storeName': storeName})"
          >
          </Notification>
        </div>
        <PlanPricingItem :yearlyMode="yearlyMode" />
      </template>
      <div class="gf_pricing__compare">
        <div class="gf_pricing-action gf_pricing__container" v-if="!showTablePricing">
          <div class="gf_pricing-action_section" @click="toggleTablePricing()">
            <div class="gf_pricing-action_section__button">
              {{ $t("dataNewPlan.plan.action.seeAllFeatures") }}
            </div>
            <div class="gf_pricing-action_section__icon">
              <i class="icon icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div class="gf_pricing-table" id="gfPricingTable">
          <PricingPlanCompare
            :isShowTablePricing="showTablePricing"
            :dataPlan="dataPlan"
            :currentPlan="plan"
            :paymentLink="paymentLink()"
            :getPriceForPlan="getPriceForPlan"
            :isShowAdvandDiscount="isShowAdvandDiscount"
            :isShowBusinessDiscount="isShowBusinessDiscount"
          />
        </div>
        <div class="gf_pricing-action gf_pricing__container" v-if="showTablePricing">
          <div class="gf_pricing-action_section" @click="toggleTablePricing()">
            <div class="gf_pricing-action_section__button">
              {{ $t("dataNewPlan.plan.action.hideAllFeatures") }}
            </div>
            <div class="gf_pricing-action_section__icon">
              <i class="icon icon-arrow-up"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="gf_pricing__enjoy">
        <PricingEnjoy />
      </div>
      <div class="gf_pricing__banner gf_pricing__container">
        <PricingBanner />
      </div>
      <div class="gf_pricing__faq gf_pricing__container">
        <PricingFAQ />
      </div>
      <div class="gf_pricing__discount">
        <PricingDiscount />
      </div>
    </PerfectScrollbar>
    <SwitchYearlyModal v-if="openBlockModal" />
  </div>
</template>

<script>
import PlanPricingItem from "@/modules/Pricing/components/PlanPricingItem/index.vue";
import PricingPlanCompare from "@/modules/Pricing/components/PricingPlanCompare/index.vue";
import PricingEnjoy from "@/modules/Pricing/components/PricingEnjoy";
import PricingBanner from "@/modules/Pricing/components/PricingBanner";
import PricingFAQ from "@/modules/Pricing/components/PricingFAQ";
import PricingDiscount from "@/modules/Pricing/components/PricingDiscount";
import dataPlan from "@/modules/Pricing/data/dataNewPlan.json";
import {mapMutations, mapState} from "vuex";
import plan from "@/modules/Pricing/mixins/plan";
import promotion from "@/modules/Pricing/mixins/promotion";
import trackEvent, { PRICING_MODEL_EVENT } from '@/utils/tracker';
import PricingPageLoading from "@/modules/Pricing/components/PricingPageLoading";
import SwitchYearlyModal from "@/modules/Pricing/components/SwitchYearlyModal";
import { mutations} from "@/store/downgrade/types";

export default {
  name: "PlanPricing",
  components: {
    PlanPricingItem,
    PricingPlanCompare,
    PricingEnjoy,
    PricingBanner,
    PricingFAQ,
    PricingDiscount,
    PricingPageLoading,
    SwitchYearlyModal
  },
  mixins: [plan(), promotion()],
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      yearlyMode: true,
      showTablePricing: false,
      dataPlan: dataPlan,
      prevRoute: "",
      prevUrl: undefined,
    };
  },
  computed: {
    ...mapState("account", {
      account: (state) => state.shopInfo,
      plan: (state) => state.shopInfo.plan,
    }),
    ...mapState("dashboard", {
      pricingPageLoading: (state) => state.pricingPageLoading,
      currentBillingInterval: state => state.paymentInfo.type,
      isYearly: state => state.isYearly,
    }),
    ...mapState("downgrade", {
      openBlockModal: (state) => state.openBlockModal,
    }),
    storeName() {
      const shopifyDomain = this.account.shopifyDomain || '';
      const pattern = /^([-a-zA-Z0-9@_~]{2,256}\.)+myshopify.com$/;
      if (pattern.test(shopifyDomain)) {
        return shopifyDomain.replace('.myshopify.com',  '');
      }
      return '';
    },
    isShowAdvandDiscount() {
      return true;
    },
    isShowBusinessDiscount() {
      return true;
    },
  },
  watch: {
    yearlyMode(value) {
      this.$eventBus.$emit('switch-yearly-mode', value);
    }
  },
  mounted() {
    this.trackingViewPricing();
    this.$eventBus.$emit('switch-yearly-mode', this.yearlyMode);
    this.$eventBus.$off('switch-yearly-mode-compare')
    this.$eventBus.$on('switch-yearly-mode-compare', (mode) => {
      this.yearlyMode = mode
    });
  },
  async created() {
    this.setPricingPageLoading(true)
    const query = this.$route.query
    if (query.from) {
      await Promise.all([this.fetchDynamicContent(), this.fetchDynamicContentTrigger(), this.fetchPaymentInfo()])
    } else {
      await Promise.all([this.fetchDynamicContent(), this.fetchPaymentInfo()])
    }
    this.setPricingPageLoading(false)
  },
  methods: {
    ...mapMutations("dashboard", {
      setPricingPageLoading: 'SET_LOADING_PRICING_PAGE',
    }),
    ...mapMutations("downgrade", {
      toggleBlockModal: mutations.TOGGLE_BLOCK_MODAL
    }),
    toggleTablePricing() {
      this.showTablePricing = !this.showTablePricing;
    },
    getPriceForPlan() {
      return;
    },
    paymentLink() {
    },
    goToDashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    leavePricingPage() {
      const url = new URL(window.location.href);
      const from = url.searchParams.get('from');
      const closeTab = url.searchParams.get('close-tab');
      if(closeTab){
        return window.close();
      }
      if(from === 'instant'){
        return window.history.back();
      }
      if (this.prevRoute.name != null) {
        this.$router.go(-1)
      } else if (this.prevUrl && typeof this.prevUrl === 'string' && this.prevUrl.includes('gempages')) {
        window.history.back();
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    },
    toggleYearlyMonthlyMode() {
      this.yearlyMode = !this.yearlyMode; 
      this.setYearlyMode(this.yearlyMode);
      return;
    },
    trackingViewPricing() {
      const url = new URL(window.location.href);
      const triggerValue = url.searchParams.get('from');
      trackEvent({
        eventId: PRICING_MODEL_EVENT.VIEW_PAGE,
        properties: {
          trigger: triggerValue ?? 'direct',
          plan: this.plan  
        }
      });
    },
    trackingClickLinkNotify(e) {
      e.preventDefault();
      if (e.target.classList.contains('gf_notify-tracking')) {
        trackEvent({
          eventId: PRICING_MODEL_EVENT.CLICK_NOTIFY_AFFILIATE,
        });
        const url = e.target.getAttribute('href');
        window.open(url, '_blank');
      }
      return;
    }
  },
  beforeRouteEnter(_, from, next) {
    const prevUrl = localStorage.getItem('gpPreviousUrl');
    localStorage.removeItem('gpPreviousUrl');
    next(vm => {
      vm.prevRoute = from;
      vm.prevUrl = prevUrl;
    });
  }
};
</script>
<style lang="scss">
.gf_pricing__container {
  max-width: 1200px;
  min-width: 1200px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 1230px) {
    max-width: 924px;
    min-width: 924px;
  }
}
</style>
<style lang="scss" scoped>
@import "./style.scss";
</style>
